import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Data/OrderStatusMappings/Handlers/LoadOrderStatusMappings";

type cartStatusProps = Parameters<typeof PopulateApiParameter>[0];

addToChainAfter(chain, PopulateApiParameter, props => {
    const additionalQueryStringParameters = (props.parameter as any).additionalQueryStringParameters;
    if (additionalQueryStringParameters === "isorderhistory") {
        props.apiParameter.additionalQueryStringParameters = {
            ...props.apiParameter.additionalQueryStringParameters,
            page: "orderhistory",
        };
    }
});
